import VTreeview from './VTreeview'
import VTreeviewNode from './VTreeviewNode'

export { VTreeview, VTreeviewNode }

export default {
  $_ifrontui_subcomponents: {
    VTreeview,
    VTreeviewNode,
  },
}
